import { ProjectState } from "./ProjectState"
import { useProjectStore} from "./ProjectStore"
import { CheckCredentials } from "../Util/Strings/Capitalize"

export function SiteIntro(){
    const val:Function = useProjectStore((state:ProjectState)=>{
        return state.setValidation
    })
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const data = Object.fromEntries(formData.entries());
        val(data)
        const loggeIn:boolean = CheckCredentials(data)
    };
    return  <div style={{marginTop:50}}> 
                <form onSubmit={handleSubmit}>
                   <div><input type='password' className='login' name='login'></input></div> 
                    <div style={{marginTop:20}}><button type='submit'>submit</button></div>
                </form>
            </div>
}
